import bWflow from './_src/bWflow.vue'
import bWflowViewer from './_src/bWflowViewer.vue'
bWflow.install = function(Vue) {
  Vue.component(bWflow.name, bWflow)
  Vue.component(bWflowViewer.name, bWflowViewer)
}

export default bWflow